export enum PopupType {
    BATTLE_RESULTS = "PopupType.BATTLE_RESULTS",
    LOSE = "PopupType.LOSE",
    WIN_LEVEL = "PopupType.WIN_LEVEL",
    WIN_STAGE = "PopupType.WIN_STAGE",
    CONFIRM = "PopupType.CONFIRM",
    SETTINGS = "PopupType.SETTINGS",
    GIFT = "PopupType.GIFT",
    OFFLINE_EARNINGS = "PopupType.OFFLINE_EARNINGS",
    LEVEL_COMPLETED = "PopupType.LEVEL_COMPLETED",
    SUGGEST_LOGIN = "PopupType.SUGGEST_LOGIN",
    PAYMENT_METHOD = "PopupType.PAYMENT_METHOD",
    NO_ADS_PURCHASE = "PopupType.NO_ADS_PURCHASE",
    REFERRAL_GIFT = "PopupType.REFERRAL_GIFT",
    DAILY_LEADERBOARD_REWARD = "PopupType.DAILY_LEADERBOARD_REWARD"
}
